export enum PRODUCT_TOUR_V2_STEPS {
  STUDY = "study",
  MY_SITUATION = "my-situation",
}
